import React, { useEffect, useRef } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { Products } from './components/Products';
import { Experience } from './components/Experience';
import { Skills } from './components/Skills';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StructuredData } from './components/StructuredData';
import { trackEvent } from './utils/analytics';

function App() {
  const viewedSections = useRef<Set<string>>(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        if (sectionTop < window.innerHeight * 0.75) {
          section.classList.add('animate-fade-in');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Track section visibility
  useEffect(() => {
    const sections = [
      { id: 'home', name: 'home' },
      { id: 'about', name: 'about' },
      { id: 'products', name: 'products' },
      { id: 'experience', name: 'experience' },
      { id: 'skills', name: 'skills' },
      { id: 'faq', name: 'faq' },
      { id: 'contact', name: 'contact' }
    ];

    const observers = sections.map(({ id, name }) => {
      const element = document.getElementById(id);
      if (!element) return null;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !viewedSections.current.has(name)) {
              trackEvent(`section-view-${name}`);
              viewedSections.current.add(name);
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(element);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, []);

  return (
    <div className="font-inter text-ink bg-bg min-h-screen">
      <StructuredData />
      <Header />
      <main>
        <Hero />
        <About />
        <Products />
        <Experience />
        <Skills />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
